// Runtime configuration helper
// Use this instead of process.env to access configuration values

/**
 * Get a configuration value from runtime config
 * Falls back to process.env for local development
 * @param {string} key - Configuration key (e.g., 'REACT_APP_API_URL')
 * @param {string} defaultValue - Default value if not found
 * @returns {string} Configuration value
 */
export const getConfig = (key, defaultValue = '') => {
  // Try runtime config first (production)
  if (window.runtimeConfig && window.runtimeConfig[key]) {
    return window.runtimeConfig[key];
  }
  
  // Fall back to process.env (local development)
  if (process.env[key]) {
    return process.env[key];
  }
  
  return defaultValue;
};

// Export commonly used config values
export const config = {
  cognitoApiUrl: () => getConfig('REACT_APP_COGNITO_API_URL'),
  cognitoDomain: () => getConfig('REACT_APP_COGNITO_DOMAIN'),
  cognitoClientId: () => getConfig('REACT_APP_COGNITO_CLIENT_ID'),
  cognitoUserPoolId: () => getConfig('REACT_APP_COGNITO_USER_POOL_ID'),
  cognitoFederateGroup: () => `${getConfig('REACT_APP_COGNITO_USER_POOL_ID')}_AmazonFederate`,
  redirectUri: () => getConfig('REACT_APP_REDIRECT_URI', window.location.origin),
  apiUrl: () => getConfig('REACT_APP_API_URL'),
  apiBaseUrl: () => getConfig('REACT_APP_API_BASE_URL'),
  websocketUrl: () => getConfig('REACT_APP_WEBSOCKET_URL'),
  contentgenWebsocketUrl: () => getConfig('REACT_APP_CONTENTGEN_WEBSOCKET_URL'),
  competitiveIntelApiUrl: () => getConfig('REACT_APP_COMPETITIVE_INTEL_API_URL'),
  skimApiUrl: () => getConfig('REACT_APP_SKIM_API_URL', 'https://tgavhq4vy7.execute-api.us-east-1.amazonaws.com/v1'),
  skimVerifyEnabled: () => getConfig('REACT_APP_SKIM_VERIFY_ENABLED', 'false') === 'true',
  agentModeEnabled: () => getConfig('REACT_APP_AGENT_MODE_ENABLED', 'true') === 'true',
  defaultMode: () => getConfig('REACT_APP_DEFAULT_MODE', 'bedrock-agent'),
  environment: () => getConfig('REACT_APP_ENV', 'sandbox'),
  debug: () => getConfig('REACT_APP_DEBUG', 'false') === 'true',
};

// Cognito group names emitted by the Pre-Token Generation Lambda.
// Backend / frontend gate against these strings, not raw LDAP group names.
export const COGNITO_GROUPS = {
  NON_GCR: 'non-gcr',
  GCR: 'gcr',
};

export default config;
